// extracted by mini-css-extract-plugin
export default {"main":"app-headersmall_main__QE2NF","menu":"app-headersmall_menu__uGulM","link":"app-headersmall_link__nbgmf"};